
import { Injectable } from '@angular/core';
import { Store } from '@node_modules/@ngrx/store';
import * as store from '@shared/store';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@shared/services/auth.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    protected appState$: Store<store.State>,
    private authLoginService:AuthService
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = this.authLoginService.getAccessToken();
    if (token && state.url === '/login') {
      this.router.navigate(['/landlord/overview']);
      return false;
    }
    return true;
  }


  
  // canActivateOld(): boolean {
  //   const accessToken: any = new LoginResponseModel().loadAccessToken();
  //   if (accessToken.accessToken) {
  //     if (accessToken.expires_in > Date.now()) {
  //       let successToken = false;
  //       const userData: AuthUserModel =
  //         new LoginResponseModel().loadUserFromStorage();
  //       if (userData && userData.id) {
  //         this.appState$.dispatch(
  //           authActions.getUserDataFromStorageAction(userData)
  //         );
  //         if (!userData.permissions.includes("operator") && userData.permissions.includes("admin")) {
  //           this.homeService.loadNotificationsNumber().subscribe(res => {
  //             successToken = true;
  //           }).add(() => {
  //             if (!successToken) {
  //               new LoginResponseModel().remove();
  //               this.router.navigate(['/login']);
  //             }
  //           })
  //         } else {
  //           successToken = true
  //         }
  //         return true;
  //       }
  //     } else {
  //       const data: RefreshTokenModel = {
  //         refresh_token: accessToken.refresh_token
  //       };
  //       let accessTokenSet = {
  //         expired_id: 0,
  //         access_token: '',
  //         token_type: '',
  //         refresh_token: ''
  //       };
  //       const headers = new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         Authorization: '',
  //       });
  //       let success = false;
  //       const item: any = this.http.post<LoginResponseModel>(
  //         `${this.rootUrl}/oauth/refresh-token`,
  //         data
  //       ).subscribe((item) => {
  //         if (item.api_token?.expires_in) {
  //           success = true;
  //           accessTokenSet = {
  //             expired_id: Date.now() + item.expires_in * 1000,
  //             access_token: item.access_token,
  //             token_type: item.token_type,
  //             refresh_token: item.refresh_token
  //           }
  //         }
  //         localStorage.setItem('AccessToken', JSON.stringify(accessTokenSet));
  //       }).add(() => {
  //         if (success) {
  //           window.location.reload();
  //         } else {
  //           new LoginResponseModel().remove();
  //           this.router.navigate(['/login']);
  //         }
  //       });
  //     }
  //   } else {
  //     this.router.navigate(['/login']);
  //   }
  //   return true;
  // }
}
